import { api } from "../../../../../utility/AxiosInceptor";
import React, { useState } from "react";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import PreviewFinalComponent from "./Preview_Final_Component";

import { ToastContainer, toast } from "react-toastify";
import { useEffect } from "react";

const Preview = ({
  setActiveIndex,
  enrollment_id,
  _id,
  csr,
  currentScreen,
  setCurrentScreen,
}) => {
  const [showFinalComponent, setShowFinalComponent] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  //get preview  information from local storage
  const previewsRes = localStorage.getItem("address");
  const parsepreviewsRes = JSON.parse(previewsRes);
  const previewInfo = parsepreviewsRes?.data;

  const productData = localStorage.getItem("productData");
  const parseproductData = JSON.parse(productData);
  const paymentStatus = localStorage.getItem("paymentstatus");
  const zipRes = localStorage.getItem("zipData");
  const loginRes = JSON.parse(localStorage.getItem("userData"));
  const companyName = loginRes?.companyName;

  //check that user come from incomplete or not
  const fromIncompl = localStorage.getItem("fromIncomplete");
  const parsefromIncompl = JSON.parse(fromIncompl);
  //check the user from rejected
  const fromRejected = localStorage.getItem("fromRejected");
  const parsefromRejected = JSON.parse(fromRejected);

  let basicData = JSON.parse(localStorage.getItem("basicData"))?.data;

  const formatDate = (date) => {
    if (!date) return ""; // Handle null or undefined dates
    return new Date(date).toLocaleDateString("en-US");
  };

  const postData = async () => {
    setIsLoading(true);
    const dataToSend = {
      csr: csr,
      userId: _id,
    };
    try {
      await api.post(`/api/user/handOverEnrollment`, dataToSend);
      setIsLoading(false);
      localStorage.removeItem("paymentstatus");
      localStorage.removeItem("address");
      localStorage.removeItem("agreeData");
      localStorage.removeItem("programmeId");
      localStorage.removeItem("fromRejected");
    } catch (error) {
      toast.error(error?.response?.data?.msg);
      setIsLoading(false);
    }
    setShowFinalComponent(true);
    // setFromIncomplete(false)
    // localStorage.setItem("fromIncomplete", JSON.stringify(fromIncomplete))
  };

  useEffect(() => {
    if (!zipRes && parsefromIncompl === false) {
      setIsChecked(true);
    } else if (!zipRes && parsefromIncompl) {
      setIsChecked(false);
    }
  }, [zipRes, parsefromIncompl]);

  const handleSign = () => {
    setChecked(true);
  };
  function ChangeIsoDateToECT(date) {
    // Given ISO formatted date/time
    const isoDate = date;

    // Convert ISO string to Date object
    const utcDate = new Date(isoDate);

    // Format the date according to Eastern Time Zone (EST/EDT)
    const estTimeString = utcDate.toLocaleString("en-US", {
      timeZone: "America/New_York",
    });
    return estTimeString;
  }
  const agreeData = localStorage.getItem("agreeData");
  const agreeDataObj = JSON.parse(agreeData);

  return (
    <>
      <ToastContainer />
      {!showFinalComponent ? (
        <div>
          <br></br>

          <div>
            <div style={{ marginTop: "2rem" }}>
              {/* <h5 className="font-bold">ENROLLMENT ID: {enrollment_id}</h5> */}
              <h2 className="prev">Preview Your Details</h2>
            </div>
            <br />

            <div className="previewdiv">
              <div className="flex justify-content-around">
                <div
                  className=""
                  style={{
                    borderRight: "1px solid #0475B4",
                    width: "45%",
                    borderStyle: "dashed",
                    borderLeft: "none",
                    borderBottom: "none",
                    height: "28rem",
                    borderTop: "none",
                    marginTop: "2rem",
                    marginBottom: "2rem",
                  }}
                >
                  <div className="flex">
                    <p className="w-6 ml-4">First Name:</p>
                    <p className="w-6">
                      {previewInfo?.firstName?.toUpperCase()}
                    </p>
                  </div>
                  <div className="flex">
                    <p className="w-6 ml-4">Service Address:</p>
                    <p className="w-6">
                      {previewInfo?.address1?.toUpperCase()}
                      {previewInfo?.address1 &&
                        previewInfo?.address2 &&
                        ", "}{" "}
                      {previewInfo?.address2?.toUpperCase()}
                    </p>
                  </div>
                  <div className="flex">
                    <p className="w-6 ml-4">City:</p>
                    <p style={{ marginLeft: "-1rem" }}>
                      {previewInfo?.city?.toUpperCase()}
                    </p>
                  </div>
                  <div className="flex ">
                    <p className="w-6 ml-4">Zip Code:</p>
                    <p className="w-6">{previewInfo?.zip}</p>
                  </div>
                  <div className="flex">
                    <p className="w-6 ml-4">DOB:</p>
                    <p className="w-6">{formatDate(previewInfo?.DOB)}</p>
                  </div>
                  <div className="flex   ">
                    <p className="w-6 ml-4">Telephone:</p>
                    <p className="w-6">{previewInfo?.contact}</p>
                  </div>

                  {parsefromRejected && basicData && basicData.currentPlan && (
                    <div className="flex">
                      <p className="w-6 ml-4">Product:</p>
                      <p className="w-6">
                        {basicData?.selectProduct?.toUpperCase()}
                      </p>
                    </div>
                  )}
                  {!parsefromRejected && parseproductData && (
                    <div className="flex  ">
                      <p className="w-6 ml-4">Product:</p>
                      <p className="w-6">
                        {parseproductData?.selectProduct?.toUpperCase()}
                      </p>
                    </div>
                  )}
                  {parsefromRejected ? (
                    <div className="flex   ">
                      <p className="w-6 ml-4">Amount:</p>
                      <p className="w-6">
                        {parseFloat(basicData?.totalAmount).toFixed(2)}
                      </p>
                    </div>
                  ) : (
                    <div className="flex   ">
                      <p className="w-6 ml-4">Amount:</p>
                      <p className="w-6">
                        {parseFloat(parseproductData?.totalAmount).toFixed(2)}
                      </p>
                    </div>
                  )}

                  {/* {
                                    parsefromRejected ? <div className="flex  ">
                                        <p className="w-6 ml-4">Amount:</p>
                                        <p className="w-6">{parseFloat(basicData?.totalAmount).toFixed(2)}</p>

                                    </div> : <div className="flex  ">
                                        <p className="w-6 ml-4">Amount:</p>
                                        <p className="w-6">{parseFloat(parseproductData?.totalAmount).toFixed(2)}</p>

                                    </div>
                                } */}
                </div>
                <div className="w-5 pt-4" style={{ paddingLeft: "2rem" }}>
                  <div className="flex">
                    <p className="w-6 ml-4">LastName:</p>
                    <p className="w-6">
                      {previewInfo?.lastName?.toUpperCase()}
                    </p>
                  </div>

                  <div className="flex">
                    <p className="w-6 ml-4">Address 2:</p>
                    <p style={{ marginLeft: "-1rem" }}>
                      {previewInfo?.address2 !== undefined &&
                      previewInfo?.address2.trim() !== ""
                        ? previewInfo?.address2.toUpperCase()
                        : "---"}
                    </p>
                  </div>
                  <div className="flex">
                    <p className="w-6 ml-4">State:</p>
                    <p className="w-6">{previewInfo?.state?.toUpperCase()}</p>
                  </div>
                  <div className="flex">
                    <p className="w-6 ml-4">Mother's Maiden Name:</p>
                    <p className="w-6">
                      {previewInfo?.maidenMotherName !== undefined &&
                      previewInfo?.maidenMotherName.trim() !== ""
                        ? previewInfo?.maidenMotherName.toUpperCase()
                        : "---"}
                    </p>
                  </div>

                  <div className="flex">
                    <p className="w-6 ml-4">SSN:</p>
                    <p className="w-6">{previewInfo?.SSN}</p>
                  </div>

                  <div className="flex ">
                    <p className="w-6 ml-4">Email:</p>
                    <p className="w-6">{previewInfo?.email?.toUpperCase()}</p>
                  </div>
                  {parsefromRejected && basicData && basicData.currentPlan && (
                    <div className="flex ">
                      <p className="w-6 ml-4">Plan:</p>
                      <p className="w-6">
                        {basicData.currentPlan.planName?.toUpperCase()}
                      </p>
                    </div>
                  )}

                  {!parsefromRejected && parseproductData && (
                    <div className="flex ">
                      <p className="w-6 ml-4">Plan:</p>
                      <p className="w-6">
                        {parseproductData.currentPlan?.planName?.toUpperCase()}
                      </p>
                    </div>
                  )}
                  {paymentStatus && paymentStatus === "paid" ? (
                    <div className="flex">
                      <p className="w-6 ml-4">Payment Method:</p>
                      <p className="w-6">CREDIT CARD</p>
                    </div>
                  ) : (
                    <div className="flex">
                      <p className="w-6 ml-4">Payment Method:</p>
                      <p className="w-6">SKIP</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <br />
            <br />
            {zipRes ? (
              <div className="flex">
                <Checkbox
                  inputId="cb1"
                  value="New York"
                  checked={isChecked}
                  onClick={handleSign}
                  onChange={(e) => setIsChecked(e.checked)}
                ></Checkbox>
                <label htmlFor="cb1" className="p-checkbox-label mx-2">
                  <p>
                    I further consent to receive calls, emails and/or text
                    messages that may deliver auto-dialed or pre-recorded
                    messages from {companyName} or its duly appointed agent,
                    either using my telephone number assigned by {companyName}{" "}
                    or provided by me herein or later. I understand this is not
                    a condition of purchase.
                  </p>
                  <p>
                    I hereby give my informed consent to electronically sign
                    this form, and I acknowledge that this electronic signature
                    has the same legal effect as a handwritten signature. I
                    understand that this action signifies my agreement to the
                    terms and conditions outlined in this form and any related
                    documents.
                  </p>
                  <br />
                  {checked ? (
                    <p>
                      <strong>
                        This form is electronically signed by <span> </span>
                        <strong>
                          {(previewInfo?.firstName).toUpperCase()}{" "}
                          {(previewInfo?.lastName).toUpperCase()}
                        </strong>
                        <span> </span>
                        on <span> </span>{" "}
                        {ChangeIsoDateToECT(new Date().toISOString())}
                      </strong>
                    </p>
                  ) : null}
                </label>
              </div>
            ) : !zipRes && parsefromIncompl === true ? (
              <div className="flex">
                <Checkbox
                  inputId="cb1"
                  value="New York"
                  checked={isChecked}
                  onClick={handleSign}
                  onChange={(e) => setIsChecked(e.checked)}
                ></Checkbox>
                <label htmlFor="cb1" className="p-checkbox-label mx-2">
                  <p>
                    I further consent to receive calls, emails and/or text
                    messages that may deliver auto-dialed or pre-recorded
                    messages from {companyName} or its duly appointed agent,
                    either using my telephone number assigned by {companyName}{" "}
                    or provided by me herein or later. I understand this is not
                    a condition of purchase.
                  </p>
                  <p>
                    I hereby give my informed consent to electronically sign
                    this form, and I acknowledge that this electronic signature
                    has the same legal effect as a handwritten signature. I
                    understand that this action signifies my agreement to the
                    terms and conditions outlined in this form and any related
                    documents.
                  </p>
                  <br />
                  {checked ? (
                    <p>
                      <strong>
                        This form is electronically signed by <span> </span>
                        <strong>
                          {previewInfo?.firstName.toUpperCase()}{" "}
                          {previewInfo?.lastName.toUpperCase()}
                        </strong>
                        <span> </span>
                        on <span> </span>{" "}
                        {ChangeIsoDateToECT(new Date().toISOString())}
                      </strong>
                    </p>
                  ) : null}
                </label>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="flex flex-row justify-content-end ">
            <Button
              className="mr-2 btn"
              label="Back"
              onClick={() => {
                if (agreeDataObj === "") {
                  setActiveIndex(1);
                  setCurrentScreen(3); // You can uncomment this line if needed
                } else {
                  setActiveIndex(0);
                }
              }}
            />
            <Button
              className="btn"
              label="Continue"
              onClick={() => {
                postData();
                localStorage.removeItem("shipmentCost");
                localStorage.removeItem("shipmentName");
                // localStorage.removeItem("checkLabel");
              }}
              disabled={!isChecked || isLoading}
              icon={isLoading === true ? "pi pi-spin pi-spinner " : ""}
            />
          </div>
        </div>
      ) : (
        <PreviewFinalComponent enrollment_id={enrollment_id} />
      )}
    </>
  );
};

export default Preview;
